import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ontos-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_formula_input = _resolveComponent("ontos-formula-input")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$tt('rules')), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rules, (rule, index) => {
      return (_openBlock(), _createBlock(_component_v_row, {
        key: _ctx.keys[index],
        dense: "",
        align: "start"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            md: "7"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_formula_input, _mergeProps({
                ref_for: true,
                ref: "editors",
                class: "required"
              }, { ref_for: true }, _ctx.bindings, {
                label: _ctx.$tt('definition.rule'),
                value: rule.rule,
                rule: index,
                draft: _ctx.draftWith,
                "result-label": _ctx.resultLabel,
                example: _ctx.example,
                onInput: ($event: any) => (_ctx.change(index, {rule: $event})),
                onValidity: ($event: any) => (_ctx.validity[_ctx.keys[index]] = $event)
              }), null, 16, ["label", "value", "rule", "draft", "result-label", "example", "onInput", "onValidity"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_col, {
            cols: "10",
            md: "4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                label: _ctx.$tt('rule-message'),
                placeholder: _ctx.$tt('validation.rule-default'),
                "persistent-placeholder": "",
                "model-value": rule.message,
                "onUpdate:modelValue": ($event: any) => (_ctx.change(index, {message: $event || undefined}))
              }, null, 8, ["label", "placeholder", "model-value", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          _createVNode(_component_v_col, {
            cols: "2",
            md: "1"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                icon: "",
                variant: "text",
                size: "small",
                title: _ctx.$tt('remove'),
                onClick: ($event: any) => (_ctx.remove(index))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-delete-outline", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["title", "onClick"])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128)),
    _createVNode(_component_v_btn, {
      variant: "text",
      "prepend-icon": "mdi-plus",
      onClick: _ctx.add
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$tt('add-rule')), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
}